// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mainWrapper":"app-components-interestform-interestform--mainWrapper","formWrapper":"app-components-interestform-interestform--formWrapper"};